import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, createElementVNode as _createElementVNode, createVNode as _createVNode, mergeProps as _mergeProps, createSlots as _createSlots, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d8d5005"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "helper-text" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = {
  key: 0,
  class: "pt-2 w-100"
}
const _hoisted_4 = { class: "d-flex align-items-center justify-content-between w-100" }
const _hoisted_5 = { class: "ml-1" }
const _hoisted_6 = { class: "font-weight-normal text-muted mx-1" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "input-group mb-3" }
const _hoisted_9 = ["for"]
const _hoisted_10 = {
  key: 0,
  class: "d-flex flex-wrap"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "form-row" }
const _hoisted_13 = { class: "form-group col-md-12 col-lg-10 col-xxl-8" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "popover-icon pi pi-question" }, null, -1))
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { class: "form-row" }
const _hoisted_18 = { class: "form-group col-md-12 col-lg-10 col-xxl-8" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "popover-icon pi pi-question" }, null, -1))
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = {
  key: 1,
  class: "d-flex flex-wrap"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user text-primary mr-1" }, null, -1))
const _hoisted_26 = {
  key: 0,
  class: "text-success"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check-circle mr-1" }, null, -1))
const _hoisted_28 = { class: "mb-3 pr-lg-5 pr-md-2" }
const _hoisted_29 = { class: "d-flex justify-content-between align-items-center w-100" }
const _hoisted_30 = { class: "d-flex align-items-center" }
const _hoisted_31 = { class: "mx-2 mb-0" }
const _hoisted_32 = { class: "mr-1 mb-0" }
const _hoisted_33 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_34 = { class: "" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "mb-1" }
const _hoisted_37 = {
  key: 0,
  class: "lead"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductPageContentSection = _resolveComponent("ProductPageContentSection")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ProductConfigurationOption = _resolveComponent("ProductConfigurationOption")!
  const _component_TrainingModuleTable = _resolveComponent("TrainingModuleTable")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_ProductConfigurationStep = _resolveComponent("ProductConfigurationStep")!
  const _component_Message = _resolveComponent("Message")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_AddressForm = _resolveComponent("AddressForm")!
  const _component_PopoverIcon = _resolveComponent("PopoverIcon")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_TrainingParticipantForm = _resolveComponent("TrainingParticipantForm")!
  const _component_ProductConfiguration = _resolveComponent("ProductConfiguration")!
  const _component_BaseProductOverviewItemCard = _resolveComponent("BaseProductOverviewItemCard")!
  const _component_ProductTabs = _resolveComponent("ProductTabs")!
  const _component_LinkButton = _resolveComponent("LinkButton")!
  const _component_Card = _resolveComponent("Card")!
  const _component_TrainingPriceSummary = _resolveComponent("TrainingPriceSummary")!
  const _component_ScrollPanel = _resolveComponent("ScrollPanel")!
  const _component_ProductConfigurationSummaryItem = _resolveComponent("ProductConfigurationSummaryItem")!
  const _component_ColumnYesNo = _resolveComponent("ColumnYesNo")!
  const _component_ProductConfigurationSummary = _resolveComponent("ProductConfigurationSummary")!
  const _component_WalletMessage = _resolveComponent("WalletMessage")!
  const _component_ProductPageSummary = _resolveComponent("ProductPageSummary")!
  const _component_ProductLayout = _resolveComponent("ProductLayout")!
  const _component_ProductAddedModal = _resolveComponent("ProductAddedModal")!
  const _component_TrainingAddCourseModal = _resolveComponent("TrainingAddCourseModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ProductLayout, {
      modelValue: _ctx.showSideBar,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.showSideBar) = $event)),
      showTeachingsMaterialButton: true,
      "help-block": _ctx.selectedHelpBlock,
      vm: _ctx.vm
    }, _createSlots({
      summary: _withCtx(() => [
        _createVNode(_component_ProductPageSummary, {
          "can-submit": !_ctx.submitted || _ctx.validateProductConfiguration(),
          "is-product-available": _ctx.vm.viewModelIsValid && _ctx.vm.isBeNeMarket && !_ctx.vm.onRequest,
          "total-price": _ctx.trainingPriceCalculation?.totalPrice,
          onAddToCart: _cache[14] || (_cache[14] = ($event: any) => (_ctx.addToCart()))
        }, {
          priceSummary: _withCtx(() => [
            _createVNode(_component_ScrollPanel, { style: {"width":"100%","height":"clamp(200px, 30vh, 300px)"} }, {
              default: _withCtx(() => [
                _createVNode(_component_TrainingPriceSummary, { vm: _ctx.trainingPriceCalculation }, null, 8, ["vm"])
              ]),
              _: 1
            })
          ]),
          configurationSummary: _withCtx(() => [
            _createVNode(_component_ProductConfigurationSummary, {
              header: _ctx.$t('training.titleSummary')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ProductConfigurationSummaryItem, {
                  content: _ctx.$t(`enum.trainingMethod.${_ctx.productStore.selectedTrainingMethod}`),
                  label: _ctx.$t('training.lblType')
                }, null, 8, ["content", "label"]),
                (_ctx.productStore.selectedTrainingMethod === 3)
                  ? (_openBlock(), _createBlock(_component_ProductConfigurationSummaryItem, {
                      key: 0,
                      label: _ctx.$t('training.lblModular')
                    }, {
                      content: _withCtx(() => [
                        _createVNode(_component_ColumnYesNo, {
                          value: 
										_ctx.productStore.selectedTrainingConfigurationOption ===
										_ctx.TrainingConfigurationOptionEnum.Custom
									
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_ProductConfigurationSummaryItem, {
                  content: _ctx.selectedLocationText,
                  label: _ctx.$t('training.lblLocation')
                }, null, 8, ["content", "label"]),
                (_ctx.productStore.trainingProductForm?.isVdiTraining)
                  ? (_openBlock(), _createBlock(_component_ProductConfigurationSummaryItem, {
                      key: 1,
                      label: _ctx.$t('training.lblVirtualDesktop')
                    }, {
                      content: _withCtx(() => [
                        _createVNode(_component_ColumnYesNo, {
                          value: _ctx.productStore.trainingProductForm.isVdiTraining
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_ProductConfigurationSummaryItem, {
                  content: _ctx.$n(_ctx.trainingPriceCalculation?.totalDurationInDays || 0).toString(),
                  label: _ctx.$t('training.lblDuration')
                }, null, 8, ["content", "label"]),
                _createVNode(_component_ProductConfigurationSummaryItem, {
                  content: _ctx.selectedDateFormatted || '-',
                  label: _ctx.$t('training.lblDate')
                }, null, 8, ["content", "label"]),
                _createVNode(_component_ProductConfigurationSummaryItem, {
                  content: _ctx.$n(_ctx.productStore.trainingParticipants?.length || 0).toString(),
                  label: _ctx.$t('training.lblNumberOfParticipants')
                }, null, 8, ["content", "label"])
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          validationMessage: _withCtx(() => [
            (_ctx.validationErrors.length && _ctx.submitted)
              ? (_openBlock(), _createBlock(_component_Message, {
                  key: 0,
                  closable: false,
                  severity: "warn",
                  style: {"cursor":"pointer"},
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.scrollToFirstValidationError()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$tc("common.productSummary.msgValidationErrors", _ctx.validationErrors.length)), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          walletMessage: _withCtx(() => [
            _withDirectives(_createVNode(_component_WalletMessage, {
              "wallet-amount": _ctx.trainingPriceCalculation?.walletAmount
            }, null, 8, ["wallet-amount"]), [
              [_vShow, !_ctx.isSmallScreen && _ctx.vm?.canUseWallet]
            ])
          ]),
          default: _withCtx(() => [
            (!_ctx.vm.isBeNeMarket || _ctx.vm.onRequest)
              ? (_openBlock(), _createBlock(_component_Card, {
                  key: 0,
                  class: "product-config-cta-card"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("h3", _hoisted_36, _toDisplayString(_ctx.vm.name), 1),
                    (!_ctx.isMobile)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(_ctx.$t('training.onrequest.text')), 1))
                      : _createCommentVNode("", true),
                    (_ctx.vm.contactPageUrl)
                      ? (_openBlock(), _createBlock(_component_LinkButton, {
                          key: 1,
                          class: "p-button-success p-button-arrow p-button-raised mt-0 mt-sm-2",
                          label: _ctx.$t('training.onrequest.button'),
                          url: _ctx.vm.contactPageUrl
                        }, null, 8, ["label", "url"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["can-submit", "is-product-available", "total-price"])
      ]),
      _: 2
    }, [
      (_ctx.vm.viewModelIsValid)
        ? {
            name: "tabs",
            fn: _withCtx(() => [
              (!_ctx.vm.isBeNeMarket || _ctx.vm.onRequest)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.$slots.blocks)
                      ? (_openBlock(), _createBlock(_component_ProductPageContentSection, {
                          key: 0,
                          type: 'media'
                        }, {
                          default: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "blocks", {}, undefined, true)
                          ]),
                          _: 3
                        }))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_ctx.vm.isBeNeMarket)
                  ? (_openBlock(), _createBlock(_component_ProductTabs, {
                      key: 1,
                      items: _ctx.productTabs
                    }, {
                      tabConfiguration: _withCtx(() => [
                        _createVNode(_component_ProductPageContentSection, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ProductConfiguration, null, {
                              default: _withCtx(() => [
                                (_ctx.productStore.availableTrainingMethods?.length)
                                  ? (_openBlock(), _createBlock(_component_ProductConfigurationStep, {
                                      key: 0,
                                      id: "step-type"
                                    }, {
                                      header: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("training.lblType")) + " ", 1),
                                        (_ctx.vm.helpBlockTrainingMethod)
                                          ? (_openBlock(), _createBlock(_component_Button, {
                                              key: 0,
                                              class: "header-explanation-text text-underline py-0 p-button-text p-button-secondary",
                                              label: _ctx.vm.helpBlockTrainingMethod?.linkText,
                                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showHelpSideBar(_ctx.vm.helpBlockTrainingMethod)))
                                            }, null, 8, ["label"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      options: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productStore.availableTrainingMethods, (option, index) => {
                                          return (_openBlock(), _createBlock(_component_ProductConfigurationOption, {
                                            key: index,
                                            disabled: _ctx.isBusy,
                                            "is-selected": option.value === _ctx.productStore.selectedTrainingMethod,
                                            option: option,
                                            onOptionSelected: ($event: any) => (_ctx.onSelectedTrainingMethodChanged(option.value))
                                          }, null, 8, ["disabled", "is-selected", "option", "onOptionSelected"]))
                                        }), 128)),
                                        _createElementVNode("div", _hoisted_1, [
                                          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.trainingMethodHelpText), 1)
                                        ]),
                                        (
												_ctx.productStore.selectedTrainingMethod ===
												_ctx.TrainingMethodEnum.inCompanyModular
											)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                              _createVNode(_component_Accordion, {
                                                "active-index": _ctx.trainingModulesAccordionActiveIndexes,
                                                class: "accordion-modules",
                                                multiple: true
                                              }, {
                                                default: _withCtx(() => [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productStore.allTrainingCourses, (course) => {
                                                    return (_openBlock(), _createBlock(_component_AccordionTab, { key: course }, {
                                                      header: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_4, [
                                                          _createElementVNode("div", _hoisted_5, [
                                                            _createTextVNode(_toDisplayString(course.name) + " ", 1),
                                                            _createElementVNode("span", _hoisted_6, " (" + _toDisplayString(_ctx.$tc(
																		"training.lblModuleCount",
																		_ctx.selectedModulesForCourse(course).length
																	)) + ") ", 1)
                                                          ])
                                                        ])
                                                      ]),
                                                      default: _withCtx(() => [
                                                        (_openBlock(), _createBlock(_component_TrainingModuleTable, {
                                                          key: course,
                                                          "is-editable": 
															_ctx.productStore.selectedTrainingConfigurationOption ===
															_ctx.TrainingConfigurationOptionEnum.Custom
														,
                                                          "training-course": course,
                                                          onSelectedModulesChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSelectedModulesChanged($event)))
                                                        }, null, 8, ["is-editable", "training-course"]))
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  }), 128))
                                                ]),
                                                _: 1
                                              }, 8, ["active-index"]),
                                              _createVNode(_component_Button, {
                                                class: "mb-3 mb-1 w-100",
                                                label: _ctx.$t('training.button.addModule'),
                                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onAddModuleClick()))
                                              }, null, 8, ["label"])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.productStore.canChooseLocation)
                                  ? (_openBlock(), _createBlock(_component_ProductConfigurationStep, {
                                      key: 1,
                                      id: "step-location"
                                    }, {
                                      error: _withCtx(() => [
                                        (
												!_ctx.trainingValidations.get(
													_ctx.TrainingValidationEnum.ValidAddressOwnLocation
												) && _ctx.submitted
											)
                                          ? (_openBlock(), _createBlock(_component_Message, {
                                              key: 0,
                                              id: `validation-msg-${_ctx.TrainingValidationEnum.ValidAddressOwnLocation}`,
                                              closable: false,
                                              severity: "error"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t("validations.address")), 1)
                                              ]),
                                              _: 1
                                            }, 8, ["id"]))
                                          : _createCommentVNode("", true),
                                        (
												!_ctx.trainingValidations.get(_ctx.TrainingValidationEnum.ValidVdiChoice) &&
												_ctx.submitted
											)
                                          ? (_openBlock(), _createBlock(_component_Message, {
                                              key: 1,
                                              id: `validation-msg-${_ctx.TrainingValidationEnum.ValidVdiChoice}`,
                                              closable: false,
                                              severity: "error"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t("validations.chooseTrainingHardware")), 1)
                                              ]),
                                              _: 1
                                            }, 8, ["id"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      header: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("training.lblLocation")) + " ", 1),
                                        (_ctx.vm.helpBlockTrainingLocation)
                                          ? (_openBlock(), _createBlock(_component_Button, {
                                              key: 0,
                                              class: "header-explanation-text text-underline py-0 p-button-text p-button-secondary",
                                              label: _ctx.vm.helpBlockTrainingLocation?.linkText,
                                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showHelpSideBar(_ctx.vm.helpBlockTrainingLocation)))
                                            }, null, 8, ["label"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      default: _withCtx(() => [
                                        (_ctx.productStore.availableTrainingLocationOptions?.length)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                              _createElementVNode("div", _hoisted_8, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productStore.getAvailableTrainingLocationOptions, (location, index) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    key: index,
                                                    class: "form-check-inline"
                                                  }, [
                                                    _createVNode(_component_RadioButton, {
                                                      modelValue: _ctx.productStore.selectedTrainingLocationOption,
                                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.productStore.selectedTrainingLocationOption) = $event)),
                                                      "input-id": `location${index}`,
                                                      name: "location",
                                                      value: location.value,
                                                      onChange: ($event: any) => (_ctx.onSelectedTrainingLocationOptionChanged(location.value))
                                                    }, null, 8, ["modelValue", "input-id", "value", "onChange"]),
                                                    _createElementVNode("label", {
                                                      class: "ml-1 mb-0",
                                                      for: `location${index}`
                                                    }, _toDisplayString(location.label), 9, _hoisted_9)
                                                  ]))
                                                }), 128))
                                              ]),
                                              (
												_ctx.productStore.selectedTrainingLocationOption ===
												_ctx.TrainingLocationOptionEnum.Cadac
											)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productStore.availableTrainingLocations, (option, index) => {
                                                      return (_openBlock(), _createBlock(_component_ProductConfigurationOption, {
                                                        key: index,
                                                        disabled: _ctx.isBusy,
                                                        "is-selected": 
												option.value?.id === _ctx.productStore.selectedTrainingLocation?.id
												,
                                                        option: option,
                                                        onOptionSelected: ($event: any) => (_ctx.onSelectedTrainingLocationChanged(option.value))
                                                      }, null, 8, ["disabled", "is-selected", "option", "onOptionSelected"]))
                                                    }), 128))
                                                  ]))
                                                : (
												_ctx.productStore.selectedTrainingLocationOption ===
												_ctx.TrainingLocationOptionEnum.OwnLocation
											)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                      _createVNode(_component_AddressForm, {
                                                        modelValue: _ctx.productStore.trainingAddress,
                                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.productStore.trainingAddress) = $event)),
                                                        ref: "trainingAddressForm",
                                                        countries: _ctx.vm.countries
                                                      }, null, 8, ["modelValue", "countries"]),
                                                      _createElementVNode("div", _hoisted_12, [
                                                        _createElementVNode("div", _hoisted_13, [
                                                          _createElementVNode("label", null, _toDisplayString(_ctx.$t("training.lblUseCadacHardware")), 1),
                                                          _createVNode(_component_PopoverIcon, { class: "d-inline-flex ml-0" }, {
                                                            content: _withCtx(() => [
                                                              _createElementVNode("span", {
                                                                innerHTML: 
																  _ctx.vm.helpBlockTrainingHardware?.items
																  ?.map((x)=>
																x.text)
																?.join('<br>')
																
                                                              }, null, 8, _hoisted_15)
                                                            ]),
                                                            default: _withCtx(() => [
                                                              _hoisted_14
                                                            ]),
                                                            _: 1
                                                          }),
                                                          _createVNode(_component_Dropdown, {
                                                            modelValue: _ctx.selectedVdiChoice,
                                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedVdiChoice) = $event)),
                                                            "option-label": "label",
                                                            "option-value": "value",
                                                            options: _ctx.vdiTrainingOptions
                                                          }, null, 8, ["modelValue", "options"])
                                                        ])
                                                      ])
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                      _createElementVNode("div", _hoisted_17, [
                                                        _createElementVNode("div", _hoisted_18, [
                                                          _createElementVNode("label", null, _toDisplayString(_ctx.$t("training.lblUseCadacHardware")), 1),
                                                          _createVNode(_component_PopoverIcon, { class: "d-inline-flex ml-0" }, {
                                                            content: _withCtx(() => [
                                                              _createElementVNode("span", {
                                                                innerHTML: 
																  _ctx.vm.helpBlockTrainingHardware?.items
																  ?.map((x)=>
																x.text)
																?.join('<br>')
																
                                                              }, null, 8, _hoisted_20)
                                                            ]),
                                                            default: _withCtx(() => [
                                                              _hoisted_19
                                                            ]),
                                                            _: 1
                                                          }),
                                                          _createVNode(_component_Dropdown, {
                                                            modelValue: _ctx.selectedVdiChoice,
                                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedVdiChoice) = $event)),
                                                            "option-label": "label",
                                                            "option-value": "value",
                                                            options: _ctx.vdiTrainingOptions
                                                          }, null, 8, ["modelValue", "options"])
                                                        ])
                                                      ])
                                                    ]))
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productStore.availableTrainingLocations, (option, index) => {
                                                return (_openBlock(), _createBlock(_component_ProductConfigurationOption, {
                                                  key: index,
                                                  disabled: _ctx.isBusy,
                                                  "is-selected": 
												option.value?.id === _ctx.productStore.selectedTrainingLocation?.id
											,
                                                  option: option,
                                                  onOptionSelected: ($event: any) => (_ctx.onSelectedTrainingLocationChanged(option.value))
                                                }, null, 8, ["disabled", "is-selected", "option", "onOptionSelected"]))
                                              }), 128))
                                            ]))
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (
										_ctx.productStore.selectedTrainingMethod === _ctx.TrainingMethodEnum.training ||
										_ctx.productStore.selectedTrainingMethod === _ctx.TrainingMethodEnum.inCompany ||
										_ctx.productStore.selectedTrainingMethod === _ctx.TrainingMethodEnum.inCompanyModular
									)
                                  ? (_openBlock(), _createBlock(_component_ProductConfigurationStep, {
                                      key: 2,
                                      id: "step-date"
                                    }, _createSlots({
                                      error: _withCtx(() => [
                                        (
												!_ctx.trainingValidations.get(
													_ctx.TrainingValidationEnum.ValidPreferredStartDate
												) && _ctx.submitted
											)
                                          ? (_openBlock(), _createBlock(_component_Message, {
                                              key: 0,
                                              id: `validation-msg-${_ctx.TrainingValidationEnum.ValidPreferredStartDate}`,
                                              closable: false,
                                              severity: "error"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t("training.message.selectPreferredDate")), 1)
                                              ]),
                                              _: 1
                                            }, 8, ["id"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      header: _withCtx(() => [
                                        (
											_ctx.productStore.selectedTrainingMethod === _ctx.TrainingMethodEnum.inCompany ||
											_ctx.productStore.selectedTrainingMethod ===
												_ctx.TrainingMethodEnum.inCompanyModular
										)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t("training.lblDate")), 1))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t("training.lblDates")), 1))
                                      ]),
                                      _: 2
                                    }, [
                                      (
										_ctx.productStore.selectedTrainingMethod === _ctx.TrainingMethodEnum.inCompany ||
										_ctx.productStore.selectedTrainingMethod === _ctx.TrainingMethodEnum.inCompanyModular
									)
                                        ? {
                                            name: "footer",
                                            fn: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t("training.lblEndDatePreference")), 1)
                                            ]),
                                            key: "0"
                                          }
                                        : undefined,
                                      (_ctx.productStore.selectedTrainingMethod === _ctx.TrainingMethodEnum.training)
                                        ? {
                                            name: "options",
                                            fn: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productStore.availableScheduledTrainings, (option, index) => {
                                                return (_openBlock(), _createBlock(_component_ProductConfigurationOption, {
                                                  key: index,
                                                  disabled: _ctx.isBusy,
                                                  "is-selected": 
											option.value?.id === _ctx.productStore.selectedScheduledTraining?.id
										,
                                                  option: option,
                                                  onOptionSelected: ($event: any) => (_ctx.onSelectedScheduledTrainingChanged(option.value))
                                                }, {
                                                  "usp-availablePlaces": _withCtx(() => [
                                                    (option.value.availablePlaces)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                                          _hoisted_25,
                                                          _createTextVNode(" " + _toDisplayString(_ctx.$tc("training.lblAvailableSeats", option.value.availablePlaces)), 1)
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  "usp-isGuaranteed": _withCtx(() => [
                                                    (option.value.guaranteed)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                                          _hoisted_27,
                                                          _createTextVNode(" " + _toDisplayString(_ctx.$t("training.lblGuaranteed")), 1)
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["disabled", "is-selected", "option", "onOptionSelected"]))
                                              }), 128))
                                            ]),
                                            key: "1"
                                          }
                                        : {
                                            name: "options",
                                            fn: _withCtx(() => [
                                              _createVNode(_component_Calendar, _mergeProps({
                                                modelValue: _ctx.selectedPreferredStartDate,
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedPreferredStartDate) = $event)),
                                                locale: _ctx.currentRegion
                                              }, _ctx.preferredDateOptions), null, 16, ["modelValue", "locale"])
                                            ]),
                                            key: "2"
                                          }
                                    ]), 1024))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_ProductConfigurationStep, { id: "step-participants" }, {
                                  error: _withCtx(() => [
                                    (
											!_ctx.trainingValidations.get(_ctx.TrainingValidationEnum.MaxParticipants) &&
											_ctx.submitted
										)
                                      ? (_openBlock(), _createBlock(_component_Message, {
                                          key: 0,
                                          id: `validation-msg-${_ctx.TrainingValidationEnum.MaxParticipants}`,
                                          closable: false,
                                          severity: "error"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("training.message.tooManyParticipants", [
												_ctx.productStore.maxParticipants,
											])), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["id"]))
                                      : _createCommentVNode("", true),
                                    (
											!_ctx.trainingValidations.get(
												_ctx.TrainingValidationEnum.AtleastOneParticipant
											) && _ctx.submitted
										)
                                      ? (_openBlock(), _createBlock(_component_Message, {
                                          key: 1,
                                          id: `validation-msg-${_ctx.TrainingValidationEnum.AtleastOneParticipant}`,
                                          closable: false,
                                          severity: "error"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("training.message.atLeastOneParticipant")), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["id"]))
                                      : _createCommentVNode("", true),
                                    (
											!_ctx.trainingValidations.get(
												_ctx.TrainingValidationEnum.UniqueEmailParticipant
											) && _ctx.submitted
										)
                                      ? (_openBlock(), _createBlock(_component_Message, {
                                          key: 2,
                                          id: `validation-msg-${_ctx.TrainingValidationEnum.UniqueEmailParticipant}`,
                                          closable: false,
                                          severity: "error"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("training.message.uniqueEmailParticipant")), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["id"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  header: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("training.lblParticipants")) + " ", 1),
                                    (_ctx.vm.helpBlockTrainingParticipants)
                                      ? (_openBlock(), _createBlock(_component_Button, {
                                          key: 0,
                                          class: "header-explanation-text text-underline py-0 p-button-text p-button-secondary",
                                          label: _ctx.vm.helpBlockTrainingParticipants?.linkText,
                                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showHelpSideBar(_ctx.vm.helpBlockTrainingParticipants)))
                                        }, null, 8, ["label"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_28, [
                                      _createVNode(_component_Accordion, {
                                        "active-index": _ctx.trainingParticipantsAccordionActiveIndexes,
                                        "onUpdate:activeIndex": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.trainingParticipantsAccordionActiveIndexes) = $event)),
                                        ref: "productStore.trainingParticipantsAccordion",
                                        multiple: true
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productStore.trainingParticipants, (participant, index) => {
                                            return (_openBlock(), _createBlock(_component_AccordionTab, { key: participant }, {
                                              header: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_29, [
                                                  _createElementVNode("div", _hoisted_30, [
                                                    _createElementVNode("h5", _hoisted_31, _toDisplayString(index + 1) + ".", 1),
                                                    _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.getParticipantName(participant)), 1)
                                                  ]),
                                                  _createVNode(_component_Button, {
                                                    class: "p-button-danger p-button-outlined p-button-rounded border",
                                                    icon: "pi pi-times",
                                                    onClick: _withModifiers(($event: any) => (_ctx.removeParticipant(index)), ["stop"])
                                                  }, null, 8, ["onClick"])
                                                ])
                                              ]),
                                              default: _withCtx(() => [
                                                _createElementVNode("small", null, _toDisplayString(_ctx.$t("training.lblOptionalFieldsIfUnknown")), 1),
                                                _createVNode(_component_TrainingParticipantForm, {
                                                  class: "mt-1",
                                                  index: index,
                                                  item: participant,
                                                  submitted: _ctx.submitted
                                                }, null, 8, ["index", "item", "submitted"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["active-index"]),
                                      (_ctx.productStore.canAddParticipants)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                            _createVNode(_component_Button, {
                                              class: "p-button-text mr-2 px-0",
                                              icon: "pi pi-plus-circle p-button-icon-lg",
                                              label: _ctx.$t('training.button.addParticipant'),
                                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.addParticipant()))
                                            }, null, 8, ["label"]),
                                            (
													_ctx.vm.loggedInUserAsParticipant &&
													!_ctx.productStore.trainingParticipants.find(
													(x)=>
												x.id === _ctx.vm.loggedInUserAsParticipant.id
												)
												)
                                              ? (_openBlock(), _createBlock(_component_Button, {
                                                  key: 0,
                                                  class: "p-button-text p-button-secondary px-0",
                                                  icon: "pi pi-user-plus p-button-icon-lg",
                                                  label: _ctx.$t('training.button.addSelfAsParticipant'),
                                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.addParticipant(_ctx.vm.loggedInUserAsParticipant)))
                                                }, null, 8, ["label"]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.vm.relatedUpSellProducts?.length)
                          ? (_openBlock(), _createBlock(_component_ProductPageContentSection, {
                              key: 0,
                              type: "upsell"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("h3", _hoisted_34, _toDisplayString(_ctx.$t("product.titleUpSell")), 1),
                                _createElementVNode("div", _hoisted_35, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vm.relatedUpSellProducts, (product) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: product,
                                      class: "col-md-6 mb-2"
                                    }, [
                                      _createVNode(_component_BaseProductOverviewItemCard, {
                                        "is-cross-sell": "",
                                        vm: product
                                      }, null, 8, ["vm"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["items"]))
                  : _createCommentVNode("", true)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue", "help-block", "vm"]),
    (_ctx.cartStore.showProductAddedModal)
      ? (_openBlock(), _createBlock(_component_ProductAddedModal, {
          key: 0,
          vm: _ctx.productAddedVm,
          onClose: _ctx.refresh
        }, null, 8, ["vm", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.trainingStore.isTrainingAddCourseModalVisible)
      ? (_openBlock(), _createBlock(_component_TrainingAddCourseModal, {
          key: 1,
          courses: _ctx.vm.relatedProductModules,
          onTrainingCourseAdded: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onTrainingCourseAdded($event)))
        }, null, 8, ["courses"]))
      : _createCommentVNode("", true)
  ], 64))
}